import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const TableContainer = styled.div`
  margin-top: 30px;
  border-radius: 12px;
  box-shadow:
    0px 0px 1px 0px rgba(0, 0, 0, 0.4),
    0px 8px 24px -6px rgba(0, 0, 0, 0.16);
  background-color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.surface.default};
  min-width: 980px;
  position: relative;
`;

export const TableInfo = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px;
`;

export const Left = styled.div``;

export const Right = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 0px;
`;

export const DescriptionContainer = styled.div`
  margin-top: 20px;
`;

export const Description = styled.p`
  margin: 0;
  width: 550px;
  overflow-wrap: break-word;
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.body)}
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
`;

export const List = styled.ul`
  margin: 0;
  margin-top: 20px;
  padding-left: 20px;
`;

export const ListItem = styled.li`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBody
      : textStyleCss(theme.atlas.typography.semantic.body)};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N600
      : props.theme.atlas.semantic.color.type.muted};
`;

export const Bold = styled.span`
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  font-weight: bold;
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 28px;
  column-gap: 10px;
`;

export const SwitchText = styled.p`
  ${({ theme }) =>
    theme.isVaultVariant
      ? theme.newTypography.textStyleBodySmall
      : textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N800
      : props.theme.atlas.semantic.color.type.default};
  margin: 0;
`;
